import { AbsenceInfo } from "./absence-info";
import { CertificateInfo } from "./certificate-info";

export class SubmitLeave {

    appLang: string
    revisionKey: string
    status: string
    employeeID: string
    prefdLang: string
    recordCreatedBy: string
    absenceInfo: AbsenceInfo
    certificateInfo: CertificateInfo
    constructor() {
        this.appLang = '';
        this.employeeID = '';
        this.prefdLang = '';
        this.absenceInfo = new AbsenceInfo()
        this.certificateInfo = new CertificateInfo()
    }
}


// WEBPACK FOOTER //
// ./src/app/bean/submit-leave.ts